<app-modal
  [(open)]="open"
  [title]="mode === 'add' ? 'Create New User' : 'View User'"
  size="medium"
  (closed)="onClose()"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
    <app-text-input type="email" label="Email" placeholder="Enter user's email" formControlName="email"></app-text-input>
    <app-text-input label="First Name" placeholder="Enter first name" formControlName="firstName"></app-text-input>
    <app-text-input label="Last Name" placeholder="Enter last name" formControlName="lastName"></app-text-input>

    <app-form-field
      label="Tenants"
      [error]="organizationControls.invalid && (organizationControls.dirty || organizationControls.touched) ? 'At least one organization must be selected.' : null"
    >
      <div formArrayName="organizationControls" class="space-y-2">
        @for (organization of organizations; track organization.id; let i = $index) {
          <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
            <app-toggle [formControlName]="i"></app-toggle>
            <span>{{ organization.name }}</span>
          </label>
        }
      </div>
    </app-form-field>
  </form>

  <ng-template modalFooter>
    <div class="flex flex-1 items-center justify-end gap-2">
      <button
        type="button"
        (click)="onClose()"
        class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken"
      >
        Cancel
      </button>
      @if (mode !== 'view') {
        <button
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid"
          class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90"
        >
          {{ mode === 'add' ? 'Create' : 'Save' }}
        </button>
      }
    </div>
  </ng-template>
</app-modal>
